<template>
  <div class="wallet-brokerage">
    <header>
      <div class="withdraw-deposit">
        <p>
          <img src="../../assets/images/wallet-img/7.png" alt="">佣金总额：￥{{brokerage_msg.all_amount}}
        </p>
        <p>
          <img src="../../assets/images/wallet-img/10.png" alt="">当前剩余：￥{{brokerage_msg.brokerage}}
        </p>
        <p @click="$router.push('/withdraw-deposit')">
          提现
        </p>
      </div>
    </header>
    <section>
      <div class="share-option-list">
        <div class="share-option-list-content" v-for="(item,index) in brokerage_msg.list" :key="index">
          <p>
            <span>
              {{item.good_name}}
            </span>
            <span>
              {{item.create_time}}
            </span>
          </p>
          <p>
            ￥{{item.money}}
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    return{
      brokerage_msg : []
    }
  },
  created(){
    let uid = JSON.parse(localStorage.getItem("uid"));
    this.$axios.post(this.domain.url+"/api/user/index/my_wallet",{
      uid : uid,
      type : 2
    }).then((res) => {
      // console.log(res.data.data)
      this.brokerage_msg = res.data.data
    })
  }
}
</script>

<style lang="less" scoped>
  .wallet-brokerage{
    width: 7.5rem;
    background: #f4f4f4;
    header{
      width: 7.5rem;
      height: 1.29rem;
      background: linear-gradient(75deg, #6987FF, #7771FF);
      display: flex;
      align-items: center;
      .withdraw-deposit{
        width: 100%;
        p{
          font-size: 0.24rem;
          font-family: PingFang SC;
          font-weight: bold;
          color: #FFFFFF;
          &:first-child{
            float: left;
            display: flex;
            align-items: center;
            img{
              width: .13rem;
              height: .24rem;
              margin-left: .24rem;
              margin-right: .1rem;
            }
          }
          &:nth-child(2){
            float: left;
            display: flex;
            align-items: center;
            img{
              width: .22rem;
              height: .24rem;
              margin-left: .21rem;
              margin-right: .1rem;
            }
          }
          &:last-child{
            float: right;
            margin-right: .2rem;
          }
        }
      }
    }
    section{
      .share-option-list{
        width: 7.1rem;
        margin: 0 auto;
        background: #fff;
        .share-option-list-content{
          width: 6.85rem;
          height: 1.68rem;
          background: #fff;
          margin: 0 auto;
          border-bottom: .01rem #EDEDEF solid;
          p{
            // text-align: center;
            &:first-child{
              float: left;
              span{
                display: block;
                line-height: .4rem;
                &:first-child{
                  font-size: 0.3rem;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #222222;
                  margin-top: .5rem;
                }
                &:last-child{
                  font-size: 0.24rem;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #919191;
                }
              }
            }
            &:last-child{
              float: right;
              font-size: 0.36rem;
              font-family: PingFang SC;
              font-weight: bold;
              color: #FF6600;
              line-height: 1.68rem;
            }
          }
        }
      }
    }
  }
</style>